import React, { useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { MenuItem, TextField, makeStyles } from '@material-ui/core'

import { taxList, NO_TAX } from '../contstants/taxes'
import { setTaxData } from '../store/prices.reducer'
import { selectTaxId } from '../store/prices.selectors'

import { selectIsPro } from '~/sale/store/sale.selectors'

const useStyles = makeStyles({
  field: {
    width: '192px',
    minHeight: '0',
  },
})

export default function TaxSelectorField() {
  const dispatch = useDispatch()

  const taxId = useSelector(selectTaxId)
  const isPro = useSelector(selectIsPro)

  const filteredTaxList = useMemo(
    () => taxList.filter((elem) => (isPro ? elem === NO_TAX : elem !== NO_TAX)),
    [isPro],
  )

  const { field } = useStyles()

  function onChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const selectedTax = filteredTaxList.find((elem) => elem.id === e.target.value)
    if (selectedTax) dispatch(setTaxData(selectedTax))
  }

  return (
    <div data-hook="tax">
      <TextField
        disabled={isPro}
        className={field}
        name="taxId"
        label="Tipo de impuesto"
        variant="outlined"
        value={taxId}
        onChange={onChange}
        select
      >
        {filteredTaxList?.map(({ name, id }) => (
          <MenuItem value={id} key={`tax-${id}`} data-hook={name}>
            {name}
          </MenuItem>
        ))}
      </TextField>
    </div>
  )
}
